import { Button, Dialog } from '@gov-nx/ui/web';
import { RezaChangeFormSection } from '../RezaChangeFormView/RezaChangeFormSection';
import { RezaChangeFormSkeleton } from '../RezaChangeFormView/RezaChangeFormSkeleton';
import {
	REZA_CHANGE_FORM_ID,
	type RezaChangeFormDialogProps,
	useRezaSwitcherLocale,
} from '@gov-nx/core/hooks';
import { Skeleton } from '../../Skeleton/Skeleton';

export const RezaChangeFormDialog = ({
	isOpen,
	title,
	onClose,
	optionsData,
	activeSwitcherReza,
	setActiveSwitcherReza,
}: RezaChangeFormDialogProps) => {
	const { t } = useRezaSwitcherLocale();

	return (
		<Dialog
			isOpen={isOpen}
			onClose={onClose}
			title={<h3>{title}</h3>}
			footer={
				optionsData.isRezaListLoading ? (
					<Skeleton
						width="30%"
						height="40px"
					/>
				) : (
					<Button
						color="primary"
						type="solid"
						form={REZA_CHANGE_FORM_ID}
						nativeType="submit">
						{t('form.button.submit')}
					</Button>
				)
			}>
			{optionsData.isRezaListLoading ? (
				<RezaChangeFormSkeleton />
			) : (
				<RezaChangeFormSection
					optionsData={optionsData}
					activeSwitcherReza={activeSwitcherReza}
					setActiveSwitcherReza={setActiveSwitcherReza}
					onAfterSubmit={onClose}
					formId={REZA_CHANGE_FORM_ID}
				/>
			)}
		</Dialog>
	);
};
